module.exports = __webpack_public_path__ + "static/media/staff.bf81043e.svg";